import styled from "@emotion/styled";
import React, { useState } from "react";

const IconQuestionComponent = ({ config, question, actions }) => {
    const isMobile = config?.mediaQueries?.maxWidth426;
    const numOptions = question?.options?.length || 0;

    const Wrapper = {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column"
    };

    const Title = {
        width: "calc(75% - 4vh)",
        borderRadius: "1vh",
        backgroundColor: "#3C3C3B",
        color: "white",
        fontSize: "3.5vh",
        padding: "2vh",
        textAlign: "center",
        fontWeight: "bold",
    }

    const OptionsWrapper = {
        display: "flex",
        flexWrap: "nowrap",
        width: "100%",
        height: isMobile ? "calc(100% - 2vh)" : "100%",
        margin: isMobile ? "1vh auto" : "0",
        padding: isMobile ? "10vh auto" : "0",
        overflow: actions.isSatisfactionOptionAllowed() && !isMobile ? "" : "auto",
        alignItems: isMobile ? "space-around" : "center",
        justifyContent: isMobile ? (actions.isNPSAllowed() || actions.isYNAllowed() ? ("space-around") : ("flex-start")) : ("center"),
        flexDirection: isMobile ? (actions.isNPSAllowed() ? ("row") : ("column")) : (actions.isNPSAllowed() ? ("column") : ("row")),
    };

    const OptionWrapper = {
        display: "flex",
        height: isMobile ? numOptions <= 2 ? "100%" : "25%" : "100%",
        flex: "1",
        cursor: "pointer",
        width: isMobile ? "100%" : "30%",
        maxWidth: isMobile ? "100%" : "30%",
        flexDirection: isMobile ? "row" : "column",
        columnGap: "3vh",
    };

    const IconWrapper = styled.div`
        ${props => `
            position: relative;
            width: 90%;
            height: auto;
            max-height: 100%;

            font-size: 5vh;
            animation-fill-mode: forwards;
            animation-duration: 2s;
            margin: auto;

            @media (max-width: 426px) {
                height: auto;
                width: auto;
                display: flex;
                justify-content: center;
                font-size: 3vh;
            }

            @keyframes iconWrapperSelect {
                to {
                    //transform: rotate(360deg); 
                }
            }

            @keyframes iconWrapperUnselect {
                to {
                   
                }
            }

            ${props.anySelected && props.rotateAll ? `
                animation-name: ${props.selected ? "iconWrapperSelect" : "iconWrapperUnselect"};
            ` : `
                animation-name: none;
            `}
        `};
    `;

    const Icon = styled.img`
        ${props => `
            width: 100%;
            height: auto;
            animation-fill-mode: forwards;
            animation-duration: 1s;
            margin: auto;
            animation-timing-function: linear;
            animation-direction: alternate;

            @media (max-width: 426px) {
                max-height: ${numOptions <= 2 ? ("21vh") : (actions.isNPSAllowed() ? ("6.7vh") : ("13vh"))};
                width: auto;
            }

            @keyframes iconSelect {
                from {
                    transform: scale(1.1);
                }
                to {
                    filter: grayscale(0%);
                    opacity: 1;
                    transform: scale(1.0);
                }
            }

            @keyframes iconUnselect {
                to {
                    /* filter: grayscale(100%);
                    opacity: 0.9; */
                }
            }

            ${props.anySelected ? `
                animation-name: ${props.selected ? "iconSelect" : "iconUnselect"};
            ` : `
                animation-name: none;
            `}
        `};
    `;

    const IconText = styled.div`
        position: absolute;
        color: white;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    `;

    const IconNPSText = styled.div`
        ${props => `
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            background-color: ${props.background};
            position: relative;
            font-size: 3vh;
            padding: 2vh;
            text-align: center;
            border-radius: 1vh;
            margin-top: 2vh;
            margin-bottom: 2vh;
        `};
    `;

    const TextSatisfaction = styled.div`
        ${props => `
            color: ${props.style.optionTextColor};
            background-color: ${props.style.optionTextBackgroundColor};
            position: relative;
            margin: auto;
            font-size: 3vh;
            padding: 2vh;
            width: 80%;
            text-align: center;
            border-radius: 1vh;
            ${props.anySelected && !props.selected ? `
                background-color: #acacac;
                opacity: 0.9;
            ` : null};
        `};
    `;

    const HorizontalWrapper = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    };

    const WrapperNPS1 = {
        display: "flex",
        flexDirection: isMobile ? (actions.isYNAllowed() ? ("row") : ("column")) : ("row"),
        justifyContent: "center",
    };

    const WrapperNPS2 = {
        display: "flex",
        flexDirection: actions.isNPSAllowed() && isMobile ? ("column") : ("row"),
        justifyContent: "space-between",
        width: actions.isNPSAllowed() && isMobile ? ("auto") : ("100%"),
        height: actions.isNPSAllowed() && isMobile ? ("100%") : ("auto"),
    };

    const Button = styled.button`
        width: 20%;
        border-radius: 1vh;
        border: none;
        background-color: ${actions.isAnySelectedOption() ? "#00963f" : "#3C3C3B"};
        color: white;
        font-size: 2.7vh;
        padding: 1vh;
        text-align: center;
        font-weight: bold;
        pointer-events: auto; 
        cursor: pointer;

        ${actions.isAnySelectedOption() ? "animation-name: activate; animation-iteration-count: infinite; animation-duration: 0.6s; animation-timing-function: linear; animation-direction: alternate; @keyframes activate {from { transform: scale(1.0); } to { transform: scale(0.95); }}" : ""}
    `;

    const Image = styled.img`
        margin-left: 1vh;
        width: 1vw;
        height: 1.8vh;
    `;

    const getImage = (option) => {
        try {
            if (option.icon) {
                return require("../../../../../assets/images/" + option.icon + ".png");
            }
        } catch (e) {
            return null;
        }
    }

    return (
        <div style={Wrapper}>
            <div style={HorizontalWrapper}>
                <div style={Title}>
                    {config.getTranslatedText(question?.questionTitle)}
                </div>
                <Button onClick={actions.timeForward}>Ok<Image src={require(`../../../../../assets/images/btn_flecha_write.png`)} /></Button>
            </div>
            <div style={OptionsWrapper}>
                <div style={WrapperNPS1}>
                    {(question?.options || []).map((option, i) => {
                        let anySelected = actions.isAnySelectedOption();
                        return (
                            <div key={"option" + i}
                                style={OptionWrapper}
                                onClick={() => { actions.selectOption(i) }}>

                                <IconWrapper anySelected={anySelected} selected={option?.selected} rotateAll={!option?.style?.showOptionTex}>
                                    <Icon src={anySelected && !option?.selected ? ((actions.isNPSAllowed() || actions.isYNAllowed()) ? (require(`../../../../../assets/images/default_icon_gray.png`)) : (require(`../../../../../assets/images/` + option.icon + `_gray.png`))) : getImage(option)}
                                        anySelected={anySelected} selected={option?.selected} />

                                    {option?.style?.showInsideOptionText ? (
                                        <IconText>{config.getTranslatedText(option?.option)}</IconText>
                                    ) : (
                                        null
                                    )}
                                </IconWrapper>
                                {option?.style?.showOptionText ? (
                                    <TextSatisfaction
                                        style={option?.style}
                                        anySelected={anySelected}
                                        selected={option?.selected}>
                                        {config.getTranslatedText(option?.option)}
                                    </TextSatisfaction>
                                ) : (
                                    null
                                )}
                            </div>
                        );
                    })}
                </div>
                {actions.isNPSAllowed() ? (
                    <div style={WrapperNPS2}>
                        <IconNPSText background={"#e20613"}>{config.getTranslatedText(actions.cardOption(0))}</IconNPSText>
                        <IconNPSText background={"#009540"}>{config.getTranslatedText(actions.cardOption(9))}</IconNPSText>
                    </div>
                ) : (null)}
            </div>
        </div>
    );
};

export default IconQuestionComponent;
